import {JsonConverter, JsonCustomConvert} from 'json2typescript';
import {Json2TypescriptUtil} from '../util/json2TypescriptUtil';
import {EmailMessage} from '../model/email/emailMessage';

@JsonConverter
export class EmailMessageConverter implements JsonCustomConvert<EmailMessage> {

    deserialize(json: any): EmailMessage {

        // const msgArr = new Array<TextMessage>();
        return Json2TypescriptUtil.getJsonConvertInstance().deserializeObject(json,EmailMessage);
        /*const temp:TSMap<string,string>= new TSMap();
        for (const key of Object.keys(json)) {
            temp.set(key, json[key]);
        }

        return temp;*/
    }

    serialize(data: EmailMessage): any {
        return JSON.stringify(data);
    }
}
